<template>
  <div class="swiper-containerBanner rounded-lg">
    <swiper
      :spaceBetween="12"
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 1000, disableOnInteraction: false }"
      :modules="modules"
      class="mySwiperBanner rounded-lg"
      effect="fade"
      :fadeEffect="{ crossFade: false }"
      :allowTouchMove="false"
    >
      <swiper-slide
        v-for="(image, index) in images"
        :key="index"
        class="rounded-lg flex items-center justify-center"
      >
        <a
          aria-label="Lien de banniére"
          :href="image.link"
          class="block w-full rounded-lg h-64 lg:h-[18.75rem]"
        >
          <template v-if="image.type === 'video'">
            <video
              :src="mobileSource(image)"
              autoplay
              muted
              playsinline
              loop
              class="w-full h-full object-fill rounded-lg"
            ></video>
          </template>

          <template v-else>
<img
  :src="mobileSource(image)"
  :alt="image.alt || 'Slide Tunisia Go Travel'"
  width="600"
  height="400"
  class="w-full h-full object-fill rounded-lg"
/>
          </template>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Autoplay, EffectFade } from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, EffectFade],
    };
  },
  props: {
    images: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(img => 'source' in img)
      }
    },
  },
  data() {
    return {
      isMobile: false
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    mobileSource(image) {
      return this.isMobile && image.source_mobile 
        ? image.source_mobile 
        : image.source;
    }
  }
};
</script>

<style scoped>
.swiper-containerBanner {
  width: 100%;
  height: 19.5rem;
}

@media (max-width: 768px) {
  .swiper-containerBanner {
    height: 16rem;
  }
}

.mySwiperBanner {
  padding-bottom: 30px;
}

.swiper-paginationBanner {
  bottom: 10px;
}
</style>